import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../assests/CSS/inquiry.css';

function Inquiry() {
  const form = useRef();
  const initialFormData = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    jobTitle: '',
    company: '',
    country: '',
    message: '',
    receiveNotification: false,
    acceptTerms: false,
  };

  const [formData, setFormData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const emailjsConfig = {
    serviceID: process.env.REACT_APP_EMAILJS_SERVICE_ID,
    templateID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
    publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await emailjs.sendForm(
        emailjsConfig.serviceID,
        emailjsConfig.templateID,
        form.current,
        emailjsConfig.publicKey
      );

      setFormData(initialFormData);
      toast.success('Thank you! Your inquiry has been submitted successfully. You should receive a confirmation email shortly.', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      console.error('Email error:', error);
      toast.error('There was an error submitting your form. Please try again later.', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div id="inquiry-form" className="inquiry-container">
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      
      <h2 className="inquiry-title">General Inquiry & Support:</h2>
      <p className="inquiry-subtitle">
        For any general questions about Thhiya, technical assistance, or other inquiries, please use the form below.
      </p>

      <form className="inquiry-form" ref={form} onSubmit={handleSubmit}>
        <div className="row">
          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="row">
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
          />
        </div>
        <div className="row">
          <input
            type="text"
            name="jobTitle"
            placeholder="Job Title"
            value={formData.jobTitle}
            onChange={handleChange}
          />
          <input
            type="text"
            name="company"
            placeholder="Company Name"
            value={formData.company}
            onChange={handleChange}
          />
        </div>
        <div className="row">
          <input
            type="text"
            name="country"
            placeholder="Country"
            value={formData.country}
            onChange={handleChange}
          />
        </div>
        <div className="row">
          <textarea
            rows="4"
            name="message"
            placeholder="Tell Us How We Can Help"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
        </div>
        <div className="checkbox-row">
          <label>
            <input
              type="checkbox"
              name="receiveNotification"
              checked={formData.receiveNotification}
              onChange={handleChange}
            />{' '}
            Wish To Receive Notification
          </label>
          <label>
            <input
              type="checkbox"
              name="acceptTerms"
              checked={formData.acceptTerms}
              onChange={handleChange}
              required
            />{' '}
            I Accept the terms and condition
          </label>
        </div>
        <motion.button
          whileTap={{ scale: 0.95 }}
          type="submit"
          className="submit-button"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </motion.button>
      </form>
    </div>
  );
}

export default Inquiry;
